<template>
    <section class="w-full">
        <div class="bg-growth rounded-full text-white p-2 fixed top-3 px-6 left-1/2 z-40" v-if="saved">{{ $t('saved') }}</div>
        <div v-if="myself && [1,2,3].includes(myself?.position)">
            <h2 class="text-xl mb-3 font-semibold text-button dark:text-growth">{{ $t('reg_form.update_password') }}</h2>
            <div v-if="loading">
                <font-awesome-icon icon="fas fa-spinner" class="animate-spin mx-auto mt-10 text-black dark:text-dark.textOnBkg" />
            </div>
            <div v-else class="mt-5">
                <MazInput
                    :label="$t('reg_form.current_password')"
                    v-model="original_password"
                    type="password"
                    :hint="message && message.success == false && message.message == 'Invalid password' ? 'Wrong password' : null"
                    :error="message && message.success == false && message.message == 'Invalid password'"
                />
                <br />
                <MazInput
                    class="mt-3"
                    :label="$t('reg_form.new_password')"
                    v-model="new_password"
                    type="password"
                />
                <br />
                <MazInput
                    class="mt-3"
                    :label="$t('reg_form.confirm_password')"
                    v-model="new_pass_again"
                    type="password"
                />
            </div>
        </div>
        
        <button @click="update_pass()" class="bg-button text-white dark:bg-growth rounded-lg p-1.5 px-2.5 mt-5">
            <font-awesome-icon v-if="button_loading" icon="fas fa-spinner" class="animate-spin mr-2" />{{ $t('save_changes') }}
        </button>
    </section>
</template>

<script setup>
    import { api_post_call, verify_token } from '@/api/api';
</script>

<script>
    export default {
        props: ['noarrow'],
        emits: ['close'],
        data() {
            return {
                myself: {},
                permissions: {},
                loading: false,
                button_loading:false,
                original_password: '',
                new_password: '',
                new_pass_again: '',
                message: null,
                saved: false
            }
        },
        methods: {
            async update_pass() {
                this.button_loading = true;
                if ((this.new_password !== this.new_pass_again)) {
                    alert(this.$t('reg_form.warning_3'));
                    this.button_loading = false;
                    return;
                }
                if (this.new_password.length < 8) {
                    alert(this.$t('reg_form.warning_2'));
                    this.button_loading = false;
                    return;
                }

                let response = await api_post_call(`users/`, {
                    action: 'update_password',
                    old_password : this.original_password,
                    new_password: this.new_password,
                    companyID: this.$cookies.get('c_id'),
                    userToken: this.$cookies.get('userToken')
                });
                this.message = response;
                setTimeout(async() => {
                    this.button_loading = false;
                }, 1000);
                if (this.message && this.message.success) {
                    this.saved = true;
                    setTimeout(async() => {
                        this.$emit('close');
                        this.saved = false;
                    }, 1000);
                }
            }
        },
        async created() {
            if (!(this.$cookies.get('c_id'))) {
                var companyID = null;
            } else {
                var companyID = this.$cookies.get('c_id');
            }
            const opravnenia = await verify_token(this.$cookies.get('userToken'), companyID, 'header');
            
            if (opravnenia) {
                if (opravnenia.selectBranch) {
                    let prev = this.$route.path;
                    this.$router.push({name:'Branches', query: { prevRoute: prev } });
                } 
                if (opravnenia.myself) {this.myself = opravnenia.myself; this.branchName = opravnenia.branchName;}
                if (opravnenia.new_permissions) {this.permissions = opravnenia.new_permissions;}
            }
        }
    }
</script>